import script from "./newFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./newFooter.vue?vue&type=script&lang=ts&setup=true"

import "./newFooter.vue?vue&type=style&index=0&id=5bcb2d34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcb2d34"]])

export default __exports__